import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VARIANT from './positionVariants';
import VerticalBreadCrumb from './BreadcrumbType/VerticalBreadCrumb';
import HorizontalBreadCrumb from './BreadcrumbType/HorizontalBreadCrumb';
import { withTheme } from '../../theme';
class BreadCrumb extends Component {
    constructor() {
        super(...arguments);
        this.breadCrumbByVariant = {
            [VARIANT.VERTICAL]: VerticalBreadCrumb,
            [VARIANT.HORIZONTAL]: HorizontalBreadCrumb,
        };
    }
    render() {
        const { positionVariant, theme } = this.props;
        const BreadCrumb = this.breadCrumbByVariant[positionVariant];
        return <BreadCrumb key={theme.lightPrimary} {...this.props}/>;
    }
}
BreadCrumb.propTypes = {
    events: PropTypes.array.isRequired,
    activeEventIndex: PropTypes.number.isRequired,
    theme: PropTypes.object,
    positionVariant: PropTypes.oneOf(Object.values(VARIANT)).isRequired,
};
const DRNBreadCrumb = withTheme(BreadCrumb);
DRNBreadCrumb.VARIANT = VARIANT;
export default DRNBreadCrumb;
